import * as React from 'react'
import Paper from '@mui/material/Paper'
import Box from '@mui/material/Box'

interface SettingsRowProps {
  left: React.ReactNode
  right: React.ReactNode
}

export function SettingsRow({ left, right }: SettingsRowProps) {
  return (
    <Paper
      variant="outlined"
      sx={{
        p: { xs: 1.5, sm: 2 },
        mb: 1.5,
        width: '100%',
        display: 'grid',
        gridTemplateColumns: {
          xs: '1fr', // ⬅️ single column on mobile
          sm: '1fr max-content', // ⬅️ two columns from sm and up
        },
        columnGap: { xs: 1, sm: 2 },
        rowGap: { xs: 1, sm: 0 }, // space between left/right when stacked
        alignItems: {
          xs: 'flex-start',
          sm: 'center',
        },
        minWidth: 0, // ⬅️ prevent overflow in parent flex/grid
      }}
    >
      {/* LEFT side: grows, wraps freely */}
      <Box sx={{ minWidth: 0 }}>{left}</Box>

      {/* RIGHT side: below on xs, to the right on sm+ */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: { xs: 'flex-start', sm: 'flex-end' },
          alignItems: 'center',
          whiteSpace: {
            xs: 'normal', // allow wrapping on mobile if needed
            sm: 'nowrap', // keep compact on desktop
          },
          ml: { xs: 0, sm: 2 },
        }}
      >
        {right}
      </Box>
    </Paper>
  )
}
